(function() {
  'use strict';
  
  function getKlaviyoInjectedBISTrigger(root, variantId) {
    if (!root) return null;
    var selectors = [
      // Common Klaviyo injected trigger patterns
      'button[data-klaviyo-id]',
      'a[data-klaviyo-id]',
      // In your theme the injected button sits in `.klaviyo-bis-button-container`
      '.klaviyo-bis-button-container button.needsClick',
      '.klaviyo-bis-button-container a.needsClick',
      '.klaviyo-bis-button-container button.needsclick',
      '.klaviyo-bis-button-container a.needsclick',
      // Sometimes it's just `.needsClick` or `.needsclick`
      'button.needsClick',
      'a.needsClick',
      'button.needsclick',
      'a.needsclick',
      'button.needsClick[data-variant-id]',
      'a.needsClick[data-variant-id]',
      'button.needsclick[data-variant-id]',
      'a.needsclick[data-variant-id]',
      // Klaviyo's kl-private-reset-css class pattern
      'button.kl-private-reset-css-Xuajs1',
      'a.kl-private-reset-css-Xuajs1'
    ];
    var candidates = root.querySelectorAll(selectors.join(','));
    if (!candidates || candidates.length === 0) return null;

    // Prefer matching variant id when available
    if (variantId) {
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el || !el.getAttribute) continue;
        var v = el.getAttribute('data-variant-id');
        if (v && String(v) === String(variantId)) return el;
      }
    }

    // Otherwise prefer a visible one
    for (var j = 0; j < candidates.length; j++) {
      var el2 = candidates[j];
      if (!el2) continue;
      var st = window.getComputedStyle(el2);
      if (st && st.display !== 'none' && st.visibility !== 'hidden') return el2;
    }

    return candidates[0];
  }

  // CREATE button if it doesn't exist, then show it.
  // STRATEGY: Always show the themed fallback button and hide Klaviyo's injected trigger.
  // The fallback proxies clicks to the hidden Klaviyo trigger to open the popup.
  function createOrShowKlaviyoButton(container, productId, variantId) {
    if (!container) return;

    // Remove duplicate fallback buttons only.
    var fallbackButtons = container.querySelectorAll('.klaviyo-bis-trigger[data-tucci-bis-fallback="1"]');
    if (fallbackButtons.length > 1) {
      for (var i = 1; i < fallbackButtons.length; i++) {
        fallbackButtons[i].remove();
      }
    }

    var fallbackBtn = container.querySelector('.klaviyo-bis-trigger[data-tucci-bis-fallback="1"]');

    // Always hide Klaviyo's injected triggers (they have inconsistent styling/placement).
    // We keep them in the DOM so their click handlers still work when proxied.
    var allInjected = document.querySelectorAll(
      'button.needsclick, a.needsclick, button.needsClick, a.needsClick, button.kl-private-reset-css-Xuajs1, a.kl-private-reset-css-Xuajs1, button[data-klaviyo-id], a[data-klaviyo-id]'
    );
    allInjected.forEach(function(el) {
      el.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; width: 0 !important; height: 0 !important; overflow: hidden !important;';
    });

    // Create fallback if it doesn't exist.
    if (!fallbackBtn) {
      fallbackBtn = document.createElement('button');
      fallbackBtn.type = 'button';
      fallbackBtn.className = 'klaviyo-bis-trigger product-form__add-button button button--primary tucci-bis-pill';
      fallbackBtn.setAttribute('data-tucci-bis-fallback', '1');
      fallbackBtn.setAttribute('data-product-id', productId);
      fallbackBtn.setAttribute('data-variant-id', variantId);
      fallbackBtn.textContent = 'Notify me when back in stock';
      container.appendChild(fallbackBtn);
    }

    // Update variant ID
    fallbackBtn.setAttribute('data-variant-id', variantId);
    container.setAttribute('data-variant-id', variantId);

    // FORCE show fallback
    container.style.cssText = 'display: block !important; visibility: visible !important;';
    fallbackBtn.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';

    // Proxy clicks to the hidden Klaviyo trigger to open the BIS popup.
    if (!fallbackBtn.getAttribute('data-klaviyo-bis-proxied')) {
      fallbackBtn.setAttribute('data-klaviyo-bis-proxied', 'true');
      fallbackBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        try {
          var curProductId = this.getAttribute('data-product-id');
          var curVariantId = this.getAttribute('data-variant-id');

          // Search the ENTIRE document for Klaviyo's injected trigger and click it.
          // Even hidden elements fire their click handlers when clicked programmatically.
          var globalInjected = getKlaviyoInjectedBISTrigger(document, curVariantId);
          if (globalInjected && globalInjected !== this) {
            globalInjected.click();
            return;
          }

          // Fallback: use Klaviyo API directly.
          if (window.klaviyo && window.klaviyo.open) {
            window.klaviyo.open({
              name: 'back-in-stock',
              product: { id: curProductId, variant_id: curVariantId }
            });
            return;
          }

          if (window._learnq && window._learnq.push) {
            window._learnq.push(['track', 'Back in Stock Click', {
              ProductID: curProductId,
              VariantID: curVariantId
            }]);
          }
        } catch (_) {
          // no-op
        }
      });
    }
  }
  
  // ULTRA SIMPLE: Show button when Add to Cart is disabled
  function showKlaviyoButton() {
    try {
      var addToCart = document.getElementById('AddToCart');
      var stickyAddToCart = document.getElementById('StickyAddToCart');
      var containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');

      // On direct `?variant=` navigation, Shopify's variant->state sync can be late.
      // Force our BIS logic to use the URL variant id.
      var urlVariantId = null;
      try {
        urlVariantId = new URLSearchParams(window.location.search).get('variant');
      } catch (e) {}

      // Only ONE visible notify button:
      // if sticky is showing, hide main; if main is showing, hide sticky.
      var stickyFormEl = document.querySelector('.product-sticky-form');
      var stickyActive = !!(stickyFormEl && !stickyFormEl.hasAttribute('hidden'));
      var activeType = stickyActive ? 'sticky' : 'main';

      // If no containers exist, try to find payment containers and create them
      if (containers.length === 0) {
        var mainPaymentContainer = document.querySelector('.product-form__payment-container');
        var stickyPaymentContainer = document.querySelector('.product-sticky-form__payment-container');
        
        if (mainPaymentContainer && addToCart && (addToCart.disabled || addToCart.classList.contains('button--ternary'))) {
          var form = mainPaymentContainer.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var productId = productIdInput ? productIdInput.value : '';
          
          var container = document.createElement('div');
          container.id = 'klaviyo-bis-button-' + (productId || 'main');
          container.className = 'klaviyo-bis-button-container';
          container.setAttribute('data-product-id', productId);
          mainPaymentContainer.appendChild(container);
          containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
        }
        
        if (stickyPaymentContainer && stickyAddToCart && (stickyAddToCart.disabled || stickyAddToCart.classList.contains('button--ternary'))) {
          var form = stickyPaymentContainer.closest('form') || document.querySelector('form[id*="product-form"]');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var productId = productIdInput ? productIdInput.value : '';
          
          var container = document.createElement('div');
          container.id = 'klaviyo-bis-button-sticky-' + (productId || 'main');
          container.className = 'klaviyo-bis-button-container';
          container.setAttribute('data-product-id', productId);
          stickyPaymentContainer.appendChild(container);
          containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
        }
      }
      
      containers.forEach(function(container) {
        var isMain = container.id.includes('klaviyo-bis-button-') && !container.id.includes('sticky');
        var isSticky = container.id.includes('sticky');
        var button = isMain ? addToCart : (isSticky ? stickyAddToCart : null);
        
        if (!button) return;

        // Hide the non-active form container immediately (prevents 2 visible buttons on sold-out).
        if (activeType === 'sticky' && isMain) {
          container.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
          return;
        }
        if (activeType === 'main' && isSticky) {
          container.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
          return;
        }

        var isBusy = button.getAttribute('aria-busy') === 'true';
        // Treat "disabled/ternary" as sold-out *only* when we're not in the middle of an add-to-cart transition.
        // loader-button sets aria-busy=true on click; we don't want BIS to flash during that.
        var isDisabled = (button.disabled || button.classList.contains('button--ternary')) && !isBusy;

        // On direct `?variant=...` loads, Shopify/theme sometimes hasn't synced inventory state yet,
        // but Klaviyo has already injected its BIS trigger for the URL variant.
        // If Klaviyo injected a non-blue trigger in the same payment area, treat as OOS.
        var paymentAreaForOos =
          button.closest('product-payment-container') ||
          button.closest('.product-form__payment-container') ||
          button.closest('.product-sticky-form__payment-container') ||
          button.parentElement;
        var hasKlaviyoOosTrigger = false;
        if (paymentAreaForOos) {
          hasKlaviyoOosTrigger = !!paymentAreaForOos.querySelector(
            '.klaviyo-bis-trigger:not([data-tucci-bis-fallback="1"])'
          );
        }

        var shouldShowNotify = isDisabled || hasKlaviyoOosTrigger;
        
        if (shouldShowNotify) {
          // Ensure the container itself is visible even if it was previously hidden inline.
          container.style.setProperty('display', 'block', 'important');
          container.style.setProperty('visibility', 'visible', 'important');
          container.style.setProperty('opacity', '1', 'important');
          
          // Get product and variant IDs
          var form = button.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
          
          var productId = container.getAttribute('data-product-id') || 
                        (productIdInput ? productIdInput.value : '') ||
                        container.id.replace('klaviyo-bis-button-', '').replace('-sticky', '');
          var variantId = container.getAttribute('data-variant-id') || 
                         (variantIdInput ? variantIdInput.value : '');

          if (urlVariantId) {
            variantId = urlVariantId;
          }

          // (previous paymentArea hide removed; we now hide all non-blue bis triggers above)
          
          // Create or show button (will handle showing only one)
          createOrShowKlaviyoButton(container, productId, variantId);

          // Ensure only ONE fallback button is visible (the one in the active container).
          try {
            var activeFallback = container.querySelector('.klaviyo-bis-trigger[data-tucci-bis-fallback="1"]');
            var allFallbacks = document.querySelectorAll('.klaviyo-bis-trigger[data-tucci-bis-fallback="1"], .tucci-bis-pill');
            allFallbacks.forEach(function(el) {
              if (!el || el === activeFallback) return;
              el.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important;';
            });
          } catch (e) {
            // no-op
          }
          
          // Hide the out-of-stock (disabled) Add to Cart button whenever notify is shown.
          button.style.setProperty('display', 'none', 'important');
        } else {
          // Hide container, show Add to Cart
          container.style.setProperty('display', 'none', 'important');
          button.style.removeProperty('display');
        }
      });
    } catch(e) {
      // Silently handle errors
    }
  }
  
  // Run immediately and on intervals
  function init() {
    showKlaviyoButton();
    setTimeout(showKlaviyoButton, 100);
    setTimeout(showKlaviyoButton, 500);
    setTimeout(showKlaviyoButton, 1000);
    // Direct `?variant=` navigation can take longer to sync Shopify's hidden inputs.
    // Add extra delayed passes so our fallback's data-product-id / data-variant-id are correct.
    setTimeout(showKlaviyoButton, 2000);
    setTimeout(showKlaviyoButton, 3000);
    setTimeout(showKlaviyoButton, 4000);

    // Klaviyo's onsite embed can inject its BIS trigger after a delay (especially on direct ?variant= URLs).
    // Observe for injected BIS triggers and re-run arbitration immediately when they appear.
    try {
      var klaviyoMutationTimer = null;
      var klaviyoObserver = new MutationObserver(function() {
        if (document.querySelector('.klaviyo-bis-trigger:not([data-tucci-bis-fallback="1"]), button.needsclick, button.needsClick, button.kl-private-reset-css-Xuajs1, [id="klaviyo-bis-button-container"]')) {
          if (klaviyoMutationTimer) clearTimeout(klaviyoMutationTimer);
          klaviyoMutationTimer = setTimeout(function() {
            showKlaviyoButton();
          }, 50);
        }
      });
      klaviyoObserver.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {
      // no-op
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Watch for variant changes
  document.addEventListener('variant:changed', function() {
    // Wait a beat so Shopify updates hidden `input[name="id"]` for the selected variant.
    setTimeout(showKlaviyoButton, 250);
  });
  
  // Watch Add to Cart button
  var observer = new MutationObserver(function() {
    showKlaviyoButton();
  });
  
  setTimeout(function() {
    var addToCart = document.getElementById('AddToCart');
    var stickyAddToCart = document.getElementById('StickyAddToCart');
    if (addToCart) observer.observe(addToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
    if (stickyAddToCart) observer.observe(stickyAddToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }, 500);

  // Watch for sticky form becoming active/inactive (scroll behavior usually toggles `hidden`)
  setTimeout(function() {
    var stickyFormEl = document.querySelector('.product-sticky-form');
    if (!stickyFormEl) return;

    var stickyObserver = new MutationObserver(function() {
      showKlaviyoButton();
    });

    stickyObserver.observe(stickyFormEl, {
      attributes: true,
      attributeFilter: ['hidden', 'class', 'style']
    });
  }, 500);
  
  // Function to update combo-box color swatch disabled states
  function updateComboBoxColorSwatches() {
    // Find all combo-box color swatches in sticky form
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;
    
    // Check all combo-box option items
    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      var colorSwatch = option.querySelector('.combo-box__color-swatch');
      if (!colorSwatch) return;
      
      // Check if the option itself has is-disabled class (added by product-variants component)
      // or is hidden/disabled (indicates out of stock variant)
      var isDisabled = option.classList.contains('is-disabled') ||
                      option.hasAttribute('disabled') ||
                      option.hasAttribute('hidden') ||
                      option.getAttribute('aria-disabled') === 'true';
      
      if (isDisabled) {
        colorSwatch.classList.add('is-disabled');
      } else {
        colorSwatch.classList.remove('is-disabled');
      }
    });
    
    // Also check the selected value display (the toggle button that shows selected option)
    var selectButtons = stickyForm.querySelectorAll('.select[aria-controls*="combo-box"]');
    selectButtons.forEach(function(selectButton) {
      var selectedValueSpan = selectButton.querySelector('.select__selected-value');
      if (selectedValueSpan) {
        var colorSwatch = selectedValueSpan.querySelector('.select__color-swatch');
        if (colorSwatch) {
          // Find the corresponding option item to check if it's disabled
          var comboBoxId = selectButton.getAttribute('aria-controls');
          if (comboBoxId) {
            var comboBox = document.getElementById(comboBoxId);
            if (comboBox) {
              var selectedValue = selectedValueSpan.textContent.trim();
              var optionItems = comboBox.querySelectorAll('.combo-box__option-item');
              optionItems.forEach(function(option) {
                if (option.textContent.trim() === selectedValue || 
                    option.getAttribute('value') === selectedValue) {
                  var isDisabled = option.classList.contains('is-disabled') ||
                                  option.hasAttribute('disabled') ||
                                  option.hasAttribute('hidden') ||
                                  option.getAttribute('aria-disabled') === 'true';
                  
                  if (isDisabled) {
                    colorSwatch.classList.add('is-disabled');
                  } else {
                    colorSwatch.classList.remove('is-disabled');
                  }
                }
              });
            }
          }
        }
      }
    });
  }
  
  
  // Update combo-box color swatches on initial load and interactions
  function initComboBoxObservers() {
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;
    
    // Initial update
    setTimeout(updateComboBoxColorSwatches, 500);
    
    // Watch for changes to is-disabled class on combo-box options
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'aria-disabled' || mutation.attributeName === 'disabled' || mutation.attributeName === 'hidden')) {
          updateComboBoxColorSwatches();
        }
      });
    });
    
    // Observe all combo-box option items
    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      observer.observe(option, {
        attributes: true,
        attributeFilter: ['class', 'aria-disabled', 'disabled', 'hidden']
      });
    });
    
    // Observe combo-box containers for new option items
    var comboBoxes = stickyForm.querySelectorAll('.combo-box');
    comboBoxes.forEach(function(comboBox) {
      observer.observe(comboBox, {
        childList: true,
        subtree: true
      });
    });
    
    // Watch for combo-box toggle state changes
    var comboBoxToggleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          var toggleButton = mutation.target;
          if (toggleButton.getAttribute('aria-expanded') === 'false' && 
              toggleButton.closest('.product-sticky-form')) {
            setTimeout(updateComboBoxColorSwatches, 100);
          }
        }
      });
    });
    
    var toggleButtons = stickyForm.querySelectorAll('[is="toggle-button"][aria-controls*="combo-box"]');
    toggleButtons.forEach(function(button) {
      comboBoxToggleObserver.observe(button, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  }
  
  // Update on combo-box interactions
  document.addEventListener('click', function(e) {
    if (e.target.closest('.combo-box__option-item') || 
        e.target.closest('.combo-box') || 
        e.target.closest('[is="toggle-button"][aria-controls*="combo-box"]') ||
        e.target.closest('.combo-box__close-button')) {
      setTimeout(updateComboBoxColorSwatches, 100);
    }
  });
  
  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'SELECT' && e.target.closest('.product-sticky-form')) {
      setTimeout(updateComboBoxColorSwatches, 150);
    }
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComboBoxObservers);
  } else {
    initComboBoxObservers();
  }
  
})();
